module.exports = __webpack_public_path__ + "509879c60cc2f9eb70cedcc6a4316d39.svg";